export function setSharedCookie(name: string, value: string, days = 30) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  
  let domain = "";
  const hostname = window.location.hostname;
  
  // If we are not on localhost or an IP address, use wildcard subdomain cookie
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isIp = /^[0-9.]+$/.test(hostname);
  if (!isLocalhost && !isIp) {
    const parts = hostname.split('.');
    if (parts.length >= 2) {
      const baseDomain = parts.slice(-2).join('.');
      domain = `; domain=.${baseDomain}`;
    }
  }
  
  document.cookie = `${name}=${encodeURIComponent(value)}${expires}; path=/${domain}; SameSite=Lax; Secure`;
}

export function getSharedCookie(name: string): string | null {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  }
  return null;
}

export function eraseSharedCookie(name: string) {
  setSharedCookie(name, "", -1);
}
